/**
 * @author Azzeta  Karmacharya
 */

import { NepaliDatePicker } from "nepali-calander";
import React, { Component } from "react";

export default class TermSetupForm extends Component {
  render() {
    return (
      <>
        {this.props.terms !== undefined
          ? this.props.terms.map((term, idx) => {
              let termNameId = `termName-${idx}`,
                startDateId = `startDate-${idx}`,
                endDateId = `endDate-${idx}`;

              return (
                <div className="form-group row" key={idx}>
                  <div className="col-sm-4">
                    <input
                      id={termNameId}
                      data-id={idx}
                      type="text"
                      className="form-control"
                      name="name"
                      onChange={(e) =>
                        this.props.handleTermChange(e, this.props.parentIndex)
                      }
                      value={term.name}
                    />
                  </div>
                  <div className="col-sm-4">
                    <NepaliDatePicker
                      type="input"
                      calendarMode={localStorage.getItem('calendar-mode')}
                      showToggle={true}
                      showNationalHoliday={false}
                      events={[]}
                      onDateSelect={(date) => {
                        this.props.handleTermChange(
                          {
                            target: { value: date.ad.date, name: "startDate", id: startDateId },
                          },
                          this.props.parentIndex
                        )
                      }
                      }
                      value={term.startDate}
                      minDate={
                        idx === 0
                          ? this.props.minStartDate
                          : this.props.terms[idx - 1].endDate !== ""
                          ? this.props.terms[idx - 1].endDate
                          : this.props.minStartDate
                      }
                      maxDate={this.props.maxEndDate}
                      disabled={
                        idx !== 0 || this.props.terms[idx - 1].endDate === ""
                      }
                    /> 
                  </div>
                  <div className="col-sm-4">
                    <NepaliDatePicker
                      type="input"
                      calendarMode={localStorage.getItem('calendar-mode')}
                      showToggle={true}
                      showNationalHoliday={false}
                      events={[]}
                      onDateSelect={(date) => {
                        this.props.handleTermChange(
                          {
                            target: { value: date.ad.date, name: "endDate", id: startDateId },
                          },
                          this.props.parentIndex
                        )
                      }
                      }
                      value={term.endDate}
                      minDate={
                         term.startDate !== ""
                          ? term.startDate
                          : this.props.minStartDate
                      }
                      maxDate={this.props.maxEndDate}
                      disabled={term.startDate === ""}
                    /> 
                  </div>
                </div>
              );
            })
          : null}
      </>
    );
  }
}
